export const FIELDS = [
  "WHE Ref Number",
  "Inspection order",
  "Inspection Date",
  "Address",
  "Description",
  "IFRS Categorisation",
  "Valuation Method",
  "Previous Valuation Date",
  "Gross Value",
  "Previous WHE Ref",
  "Previous WHE Gross Valuation",
  "Previous Residual Valuation",
  "Previous Depreciable Valuation",
];

export const FIELDS_REQUIRED = [
  "WHE Ref Number",
  "Inspection order",
  "Address",
  "Description",
  "IFRS Categorisation",
  "Valuation Method",
];

export const CSV_EXPORT = [
  {
    wheRef: "",
    hdcAssetReference: "",
    inspectionDate: "",
    address: "",
    description: "",
    ifrsCategorization: "",
    valuationMethod: "",
    prevValuationDate: "",
    grossValue: "",
    prevWheRef: "",
    prevWheGrossValuation: "",
    prevResidualValuation: "",
    prevDepreciableValuation: "",
  },
];

export const inspectionHeaders = [
  { id: 1, name: "Structure" },
  { id: 2, name: "Roof" },
  { id: 3, name: "M&E" },
  { id: 4, name: "Externals" },
  { id: 5, name: "NIA/GIA/GEA" },
];

export const getBackground = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((sw) => {
      sw.sync.register("request-alert");
    });
  }
};
